<template>
  
    <div :class="isLoading ? 'is-loading' : ''">

        <div v-if="errorMessage.length" class="alert alert-danger mb-4">
            <p>
                {{ errorMessage }}
            </p>
        </div>
        <div v-if="successMessage.length" class="alert alert-primary mb-4">
            <p>
                {{ successMessage }}
            </p>
        </div>

        <form ref="form" class="form-dark" @submit.prevent="submit()">

            <div class="mb-3">
                <select id="type" name="type" class="form-select text-uppercase" v-model="form.type">
                    <option v-for="type in announcementTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                </select>
            </div>
            <div class="mb-3">
                <input type="email" id="email" class="form-control" :placeholder="`${translate('Your e-mail address')}:`" v-model="form.email">
            </div>
            <div class="mb-3">
                <input type="text" id="subject" class="form-control" :placeholder="`${translate('Subject')}*:`" v-model="form.subject" required>
            </div>
            <div class="mb-3">
                <textarea name="message" id="message" class="form-control" rows="7" :placeholder="`${translate('Message')}*:`" v-model="form.message" required></textarea>
            </div>
            <div class="mb-3">
                <label class="w-100" for="file">
                    <div class="p-0 form-control d-flex justify-content-between">
                        <span class="d-inline-block py-2 px-3 min-w-0">
                            <span class="d-block py-1 text-truncate">
                                {{ form.file?.name ? form.file?.name : translate('Add attachment') }}
                            </span>
                        </span>
                        <div class="flex-shrink-0 rounded text-white bg-primary px-3 d-flex align-items-center jusitfy-content-center">
                            <svg class="flex-shrink-0 icon-upload">
                                <use xlink:href="#icon-upload"></use>
                            </svg>
                        </div>
                    </div>
                    <input class="visually-hidden" type="file" id="file" @change="onFileChanged($event)">
                </label>
            </div>

            <button type="submit" class="btn btn-secondary px-5 py-2 fs-6 mt-4">
                {{ translate('Send') }}
            </button>

        </form>

    </div>

</template>

<script>
    import { translate } from '@/scripts/mixins/translations';

    export default {
        mixins: [
            translate
        ],
        data(){
            return {
                isLoading: false,
                form: {
                    type: '',
                    email: '',
                    subject: '',
                    message: '',
                    file: ''
                },
                announcementTypes: [],
                errorMessage: '',
                successMessage: ''
            }
        },
        methods: {
            loadAnnouncementTypes(){
                this.isLoading = true;

                axios.get('announcement/list')
                .then(response => {
                    const { data } = response;

                    this.announcementTypes = data;

                    // set first type as pre selected
                    this.form.type = this.announcementTypes[0]?.id;
                })
                .finally(() => {
                    this.isLoading = false;
                });
            },
            submit(){

                // reset messages
                this.successMessage = '';
                this.errorMessage = '';

                // check file size
                if ( ! this.isFileAcceptable() )
                {
                    this.errorMessage = this.translate('Attachment too large');
                    return;
                } 

                this.isLoading = true;

                // prepare formData
                let formData = new FormData();

                for ( let key in this.form )
                {
                    let val = this.form[key];
                    formData.append(key, val);
                }

                // send to server
                axios.post(`announcement/add`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }   
                    }
                ).then(response => {
                    const { data } = response;
                    this.successMessage = data.message;

                    // reset form after success
                    this.form.type = this.announcementTypes[0]?.id;
                    this.form.email = '';
                    this.form.subject = '';
                    this.form.message = '';
                    this.form.file = '';
                    this.$refs.form.reset(); // reseting due to file input -> maintains attached file
                })
                .catch(err => {
                    if ( err.response.data?.message?.length ) {
                        this.errorMessage = err.response.data.message;
                    }
                    else
                    {
                        this.errorMessage = '';
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
            },
            onFileChanged(event){
                const target = event.target;

                if ( ! target?.files ){
                    return;
                }

                this.form.file = target.files[0];
            },
            isFileAcceptable(){
                return !this.form.file || this.form.file?.size / 1024 / 1024 <= 2; // to MB
            }
        },
        mounted(){
            this.loadAnnouncementTypes();
        }
    }
</script>